import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "DocumentClientAddress"
}
const _hoisted_2 = { key: 0 }

import { PropType } from "vue";
import { Document, Client } from "@/types";
import InnInput from "@/components/ds/input/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentClientAddress',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
    editable: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.client)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("b", null, _toDisplayString(__props.client.name), 1)
        ]),
        _createElementVNode("div", null, [
          (__props.editable)
            ? (_openBlock(), _createBlock(InnInput, {
                key: 0,
                modelValue: __props.document.clientName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.document.clientName) = $event)),
                placeholder: "Contactpersoon",
                compact: ""
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(__props.document.clientName), 1)
              ], 64))
        ]),
        _createElementVNode("div", null, _toDisplayString(__props.client.street), 1),
        _createElementVNode("div", null, _toDisplayString(__props.client.zipcode) + " " + _toDisplayString(__props.client.city), 1),
        (__props.client.international)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "VAT: " + _toDisplayString(__props.client.vat), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})